var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGooglePlayBlack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.454 16.477 5.67.914l20.08 11.337-4.297 4.226ZM1.552 0C.622.478 0 1.35 0 2.483v31.034C0 34.65.622 35.523 1.552 36l18.35-18.003L1.552 0Zm30.407 15.866-4.212-2.399-4.698 4.536 4.698 4.537 4.298-2.399c1.287-1.005 1.287-3.27-.086-4.275ZM5.671 35.093l20.08-11.337-4.297-4.226L5.67 35.093Z",
    fill: "#25282B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGooglePlayBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/google_play__black.917f29319b8a8ead0227a51fcf744d80.svg";